import { cookiesStorage } from '$utils/services/cookiesStorage'

export const handleCookiesPreferences = (cookiesPreferencesState: Boolean) => {
  return cookiesStorage.saveCookie('cookiesPreferences', cookiesPreferencesState.toString())
}



// WEBPACK FOOTER //
// ./src/services/user/cookiesPreferences/handleCookiesPreferences.service.ts